import { Constants } from '../_constants/constants';

export class ForgotPasswordTokenParametersDto {
    username: string;
    recaptchaToken: string;
    portalType = Constants.portalType;

    getQueryString(): string {
        return `username=${this.username}&recaptchaToken=${this.recaptchaToken}&portalType=${this.portalType}`;
    }
}
